<template>
  <div ref="iframeWrapper" class="credentials-iframe-wrapper"></div>
</template>

<script setup lang="ts">
import { Credentials } from '@/store/auth/types';
import { defineEmits, defineProps, onMounted, ref } from 'vue';
// eslint-disable-next-line vue/no-setup-props-destructure
const { adminUrls, timeoutMs } =
  defineProps<{
    adminUrls: string[];
    timeoutMs: number;
  }>();

const emit =
  defineEmits<{
    (e: 'credentialsFound', credentials: Credentials): void;
    (e: 'noCredentialsFound'): void;
  }>();

const iframeWrapper = ref<HTMLIFrameElement | null>(null);

const isCredentials = (maybeCreds: any): maybeCreds is Credentials =>
  !!maybeCreds && !!maybeCreds['access-token'] && maybeCreds.client && maybeCreds.uid;

const checkAdminUrl = (adminUrl: string): Promise<Credentials | 'none'> => {
  const iframe = document.createElement('iframe');
  iframe.src = `${adminUrl}/auth/browser-extension-provider`;
  iframe.className = 'credentials-iframe';

  const credentialsPromise = new Promise<Credentials | 'none'>((resolve) => {
    const listener = (messageEvent: MessageEvent<any>): void => {
      if (messageEvent.origin !== adminUrl) {
        return;
      }

      removeEventListener('message', listener);
      iframe.remove();
      resolve(isCredentials(messageEvent.data) ? messageEvent.data : 'none');
    };

    addEventListener('message', listener);
    setTimeout(() => {
      removeEventListener('message', listener);
      iframe.remove();
      resolve('none');
    }, timeoutMs);
    iframeWrapper.value?.appendChild(iframe);
  });

  return credentialsPromise;
};

onMounted(async () => {
  for (const adminUrl of adminUrls) {
    const credsOrNone = await checkAdminUrl(adminUrl);

    if (credsOrNone !== 'none') {
      emit('credentialsFound', credsOrNone);
      return;
    }
  }

  emit('noCredentialsFound');
});
</script>

<style lang="scss">
.credentials-iframe-wrapper {
  display: none;
}

.credentials-iframe {
  display: none;
  pointer-events: none;
  width: 0;
  height: 0;
}
</style>
